import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
//import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import React, { Component } from 'react';

import {Dropdown, IconButton, Icon, Button} from 'rsuite';
import { MdManageSearch } from "react-icons/md";
import { MdDone } from "react-icons/md";
import { MdClose } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');
require('datatables.net-buttons/js/dataTables.buttons.min');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require('jszip');
require('datatables.net-buttons/js/buttons.html5.min');
window.JSZip = jzip;

// Quita acentos/diacríticos (José -> Jose) para que el buscador de las
// tablas encuentre resultados sin importar si el usuario escribe o no los
// acentos, y sin importar si el dato guardado los tiene o no.
const stripAccents = (str) => str === null || str === undefined ?
    str
: str.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// DataTables solo le aplica su formateador de tipo (ext.type.search) al dato
// de cada celda, nunca al término que escribe el usuario — por eso hay que
// además reenganchar el input de búsqueda más abajo (en setTable) para
// normalizar lo que se escribe. Se envuelve el formateador original en vez
// de reemplazarlo para no perder el strip de tags HTML / saltos de línea
// que ya hace por defecto.
const defaultHtmlTypeSearch = $.fn.dataTable.ext.type.search.html;
const defaultStringTypeSearch = $.fn.dataTable.ext.type.search.string;
$.fn.dataTable.ext.type.search.html = (data) => stripAccents(defaultHtmlTypeSearch(data));
$.fn.dataTable.ext.type.search.string = (data) => stripAccents(defaultStringTypeSearch(data));

class TableList extends Component{
    constructor(props){
        super(props);

        this.setTable = this.setTable.bind(this);
        this.resetTable = this.resetTable.bind(this);
        this.triggerButton = this.triggerButton.bind(this);

        this.state = {
            disabled_new: false,
            message:"",
            // React siempre pinta la <table> cruda (todas las columnas, sin
            // buscador/exportar/paginación) antes de que setTable() la
            // envuelva con DataTables — depender del modal de carga para
            // tapar esa ventana es frágil (cualquier hueco de timing la deja
            // ver). Se oculta con CSS hasta que dtReady sea true, sin
            // importar qué tan rápido/lento sea el fetch que la dispara.
            dtReady: false,
            // Se usa como key del <table> — cambiarlo fuerza a React a
            // desmontar el nodo <table> viejo y montar uno completamente
            // nuevo en cada resetTable(). La extensión fixedColumns de
            // DataTables tiene bugs conocidos donde .destroy() no limpia
            // del todo su DOM auxiliar (clones de columnas/scroll wrapper);
            // reinicializar sobre ese residuo revienta con errores como
            // "_DT_CellIndex" de undefined. Un <table> desde cero por ciclo
            // elimina esa clase de bug de raíz, sin depender de que
            // DataTables limpie perfecto.
            tableKey: 0,
        }
    }
    

    componentDidMount(){
        this.props.onRef(this);
        //console.log(this.props)
    }

    componentDidUpdate(){
        // Mantiene la visibilidad real de columnas de DataTables sincronizada
        // con this.props.columns — es la única fuente de verdad (checkbox
        // controlado por React). Antes había también un listener jQuery
        // delegado en document que se reañadía en cada setTable() sin
        // quitar el anterior; tras el primer resetTable() (p.ej. al editar
        // un registro) el handler viejo apuntaba a una instancia de
        // DataTables ya destruida y su excepción bloqueaba al handler nuevo.
        if(this.dtInstance){
            this.props.columns.forEach((col, i)=>{
                var column = this.dtInstance.column(i);
                if(column.visible() !== col.visible){
                    column.visible(col.visible);
                }
            });
        }
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    resetTable(){
        // Si el <table> se montó apenas ahora (p.ej. Home.js cambia de vista
        // de tarjetas a lista, o cualquier otro screen que monta TableList
        // condicionalmente) no hay ninguna instancia de DataTables que
        // destruir todavía — this.dtInstance sigue en su valor inicial
        // (undefined). Forzar aquí el ciclo destroy()+remount-por-key de
        // todos modos monta un <table key=0> y lo vuelve a desmontar/montar
        // como key=1 en el mismo commit en el que React también está
        // desmontando lo que había antes de TableList (p.ej. las cards) —
        // esa carrera es lo que producía el "Failed to execute 'removeChild'
        // on 'Node'" al entrar a la vista de lista. En un mount nuevo no hay
        // nada que resetear: setTable() ya inicializa limpio.
        if(!this.dtInstance){
            return;
        }
        this.$el = $(this.el);
		this.$el.DataTable().destroy();
        // Sin esto, componentDidUpdate (dispara con el setState de abajo,
        // antes de que setTable() cree la instancia nueva) sigue viendo
        // this.dtInstance como "truthy" y llama .column(i) sobre la
        // instancia ya destruida — deja el <table> en un estado interno
        // corrupto que después hace tronar la re-inicialización de
        // DataTables ("_DT_CellIndex" de undefined en _fnCreateTr).
        this.dtInstance = null;
        this.setState({dtReady: false, tableKey: this.state.tableKey + 1});
	}

    triggerButton(className){
        // Dispara un botón ya registrado en DataTables Buttons (excelHtml5/pdfHtml5)
        // desde fuera del componente, sin duplicar la lógica de exportación.
        if(this.dtInstance){
            this.dtInstance.button('.'+className).trigger();
        }
    }

    setTable(){
        this.$el = $(this.el);
        var fixColumns = [];
        var employeeColumns = [];
        this.props.columns.forEach((c, i)=>{
            // groupClass es opcional (p.ej. Entries.js lo usa para separar
            // visualmente los bloques Empleado/Entrada/Salida) — DataTables
            // lo aplica tanto al <th> como a cada <td> de esa columna, y
            // sobrevive a los clones que hace con scrollX/fixedColumns
            // (a diferencia de un selector CSS nth-child, que no).
            if(c.width !== undefined || c.groupClass){
                var def = {targets: i};
                if(c.width !== undefined) def.width = c.width;
                if(c.groupClass) def.className = c.groupClass;
                fixColumns.push(def);
            }
        });

        var objEvidencesButton = this.props.screen === 'visit'? {
            //evidencias
            text:this.props.t('button.download_evidences'),
            className: "rs-btn rs-btn-default "+(this.props.data.length > 0 ? "s-btn-primary" : "rs-btn-disabled"),
            disabled:true,
            action:( e, dt, node, config )=>{
                /**/
                $('.rs-btn-default').blur();
                if (this.props.data.length > 0 ) {
                    this.props.downloadEvidences(); 
                }
                                     
            }
        }: {}
        
        var table = this.$el.DataTable({
            dom: 'Bfrtip',            
            buttons: this.props.report ?
                [
                    objEvidencesButton,
                    {
                        extend: 'excelHtml5',
                        className: "rs-btn rs-btn-default "+(this.props.data.length > 0 ? "toolbar-btn-outline" : ""),
                        title: this.props.filename,
                        exportOptions:{
                            stripHtml: false,
                            format:{
                                header:(data, col, row)=>{
                                    if(this.props.screen === 'check-in-face'){
                                        
                                        if(data.indexOf('rs-icon-smile-o') !== -1){
                                            data = this.props.t('screen.reports.'+this.props.screen+'.columns.face')
                                        }

                                        if(data.indexOf('rs-icon-camera') !== -1){
                                            data = this.props.t('screen.reports.'+this.props.screen+'.columns.photo')
                                        }
                                        
                                    }else if(this.props.screen === 'entries'){
                                        if(data.indexOf('rs-icon-smile-o') !== -1){
                                            data = this.props.t('screen.reports.'+this.props.screen+'.columns.face')
                                        }
                                        
                                    }
                                    
                                    return data;
                                    
                                },
                                body: (data, column, row)=>{
                                    // DataTables exporta el HTML ya renderizado de la celda, no el string
                                    // crudo que arma Home.js — hay que desenvolver los componentes visuales.
                                    if(typeof data === 'string' && data.indexOf('table-type-pill') !== -1){
                                        var pillMatch = data.match(/>([^<]*)<\/span>/);
                                        return pillMatch ? pillMatch[1] : data;
                                    }
                                    if(typeof data === 'string' && data.indexOf('table-face-badge') !== -1){
                                        return data.indexOf('is-valid') !== -1 ? this.props.t('general.yes') : this.props.t('general.no');
                                    }
                                    if(typeof data === 'string' && data.indexOf('table-location-warning') !== -1){
                                        return this.props.t('screen.reports.employees_activity.out_of_range');
                                    }

                                    if(this.props.screen === 'check-in-face'){
                                        if(row === 2 || row === 6){
                                            if(data.indexOf('rs-icon-close') !== -1){
                                                data = this.props.t('general.no');
                                            }else{
                                                if(data !== "")
                                                    data = this.props.t('general.yes');
                                            }                                            
                                        }

                                        if((row === 3 || row === 7) && data !== ''){
                                            var dato = this.props.data[column][row].split('/');
                                            var lat = parseFloat(dato[dato.length - 2]).toFixed(4);
                                            var lon = parseFloat(dato[dato.length - 1]).toFixed(4);

                                            data = 'Lat: '+lat+', Lon:'+lon;
                                        }

                                        if(row === 4 || row === 8){
                                            data = '';
                                        }
                                    }else if(this.props.screen === 'entries' || this.props.screen === 'overtime'){
                                        if(row === 2 || row === 5){
                                            if(data.indexOf('rs-icon-close') !== -1){
                                                data = this.props.t('general.no');
                                            }else{
                                                if(data !== "")
                                                    data = this.props.t('general.yes');
                                            }
                                        }
                                    }else if(this.props.screen === 'visit'){
                                        if(row === 2 || row === 4){
                                            if(data.indexOf('title="Initial Loc') !== -1 || data.indexOf('title="Loc. inicial') !== -1){
                                                var init_loc = this.props.data[column].findIndex(obj => 
                                                    obj.indexOf('start_location/') !== -1
                                                );

                                                if(init_loc !== -1){
                                                    var dato = this.props.data[column][row].split('/');
                                                    var lat = parseFloat(dato[dato.length - 2]).toFixed(2);
                                                    var lon = parseFloat(dato[dato.length - 1]).toFixed(2);

                                                    data = 'Lat: '+lat+', Lon:'+lon;
                                                }
                                            }

                                            if(data.indexOf('title="End Loc') !== -1 || data.indexOf('title="Loc. final') !== -1){
                                                var end_loc = this.props.data[column].findIndex(obj => 
                                                    obj.indexOf('end_location/') !== -1
                                                );

                                                if(end_loc !== -1){
                                                    var dato = this.props.data[column][row].split('/');
                                                    var lat = parseFloat(dato[dato.length - 2]).toFixed(2);
                                                    var lon = parseFloat(dato[dato.length - 1]).toFixed(2);

                                                    data = 'Lat: '+lat+', Lon:'+lon;
                                                }
                                            }                                                                                        
                                        }

                                        if(row === 6){
                                            var evidence = this.props.data[column].findIndex(obj =>
                                                obj.indexOf('evidence/one') !== -1
                                            );

                                            if(evidence !== -1){
                                                data = this.props.t('general.yes');
                                            }else{
                                                data = this.props.t('general.no');
                                            }
                                        }
                                    }else if(this.props.screen === 'tracking'){
                                        // Acá siempre es icon/map-marker (nunca hay nombre de
                                        // ubicación como en Visit) — se distingue el caso "sin
                                        // ubicación" por el marcador no_action del dato crudo,
                                        // no por el título del ícono ya renderizado.
                                        if(row === 2 || row === 4){
                                            var raw = this.props.data[column][row];

                                            if(raw.indexOf('no_action') === -1){
                                                var dato = raw.split('/');
                                                var lat = parseFloat(dato[dato.length - 2]).toFixed(4);
                                                var lon = parseFloat(dato[dato.length - 1]).toFixed(4);

                                                data = 'Lat: '+lat+', Lon:'+lon;
                                            }else{
                                                data = this.props.t('screen.reports.tracking.columns.no_location');
                                            }
                                        }

                                        if(row === 6){
                                            data = '';
                                        }
                                    }

                                    return data;
                                    
                                },
                            }
                        }
                    },
                    {
                        extend: 'pdfHtml5',
                        className: "rs-btn rs-btn-default "+(this.props.data.length > 0 ? "toolbar-btn-outline" : ""),
                        title: this.props.filename,
                        orientation:"landscape",
                        customize:(doc)=>{

                            doc.content[1].table.body.map((body, i)=>{
                                if(i > 0){
                                    var typeIdx = this.props.data[i-1].findIndex(obj =>
                                        typeof obj === 'string' && obj.indexOf('type/') === 0
                                    );
                                    if(typeIdx !== -1){
                                        // "type/<label>/<in|out>" — desenvuelve al texto plano para el export.
                                        body[typeIdx] = {text: this.props.data[i-1][typeIdx].split('/')[1]};
                                    }

                                    if(this.props.screen === 'visit' || this.props.screen === 'tracking'){
                                        // start_location/end_location usan el mismo formato
                                        // crudo en ambas pantallas (icon/map-marker/.../
                                        // start_location|end_location/...), así que el mismo
                                        // hallazgo por substring funciona para las dos.
                                        var init_loc = this.props.data[i-1].findIndex(obj =>
                                            obj.indexOf('start_location/') !== -1
                                        );

                                        if(init_loc !== -1){
                                            var data = this.props.data[i-1][init_loc].split('/');
                                            var lat = parseFloat(data[data.length - 2]).toFixed(2);
                                            var lon = parseFloat(data[data.length - 1]).toFixed(2);

                                            body[init_loc] = {text:'Lat: '+lat+', Lon:'+lon};
                                        }

                                        var end_loc = this.props.data[i-1].findIndex(obj =>
                                            obj.indexOf('end_location/') !== -1
                                        );

                                        if(end_loc !== -1){
                                            var data = this.props.data[i-1][end_loc].split('/');
                                            var lat = parseFloat(data[data.length - 2]).toFixed(2);
                                            var lon = parseFloat(data[data.length - 1]).toFixed(2);

                                            body[end_loc] = {text:'Lat: '+lat+', Lon:'+lon};
                                        }

                                        if(this.props.screen === 'visit'){
                                            var evidence = this.props.data[i-1].findIndex(obj =>
                                                obj.indexOf('evidence/one') !== -1
                                            );

                                            if(evidence !== -1){
                                                body[evidence] = {text: this.props.t('general.yes')};
                                            }else{
                                                body[evidence] = {text: this.props.t('general.no')};
                                            }
                                        }else{
                                            // La última columna ("route") es solo un ícono de
                                            // acción, sin dato real que exportar.
                                            body[6] = {text: ''};
                                        }

                                    }else{
                                        var check = this.props.data[i-1].findIndex(obj => 
                                            obj.indexOf('entry/') !== -1  
                                        );

                                        if(check !== -1){ 
                                            if(this.props.data[i-1][check].indexOf('red') === -1){
                                                body[check] = {text: this.props.t('general.yes')};
                                            }else{
                                                body[check] = {text: this.props.t('general.no')};
                                            }
                                            
                                        }

                                        var close = this.props.data[i-1].findIndex(obj => 
                                            obj.indexOf('out/') !== -1  
                                        );

                                        if(close !== -1){
                                            if(this.props.data[i-1][close].indexOf('red') === -1){
                                                body[close] = {text: this.props.t('general.yes')};
                                            }else{
                                                body[close] = {text: this.props.t('general.no')};
                                            }
                                        }

                                        this.props.data[i-1].map((d, j)=>{
                                            if(d.indexOf('data:image') !== -1){
                                                body[j] = {image:d, width:30}
                                            }

                                            return d;
                                        });
                                    }
                                    
                                    
                                }else{
                                    body.map((b, j)=>{
                                        if(b.text === ""){
                                            b.text = this.props.t('screen.reports.'+this.props.screen+'.columns.'+this.props.columns[j].title)
                                        }

                                        return b;
                                    })
                                }
                                return body;
                            });

                            if(this.props.table_title.length > 0){
                                var title = [];
                                this.props.table_title.map((t)=>{
                                    title.push({
                                        text: t.title ? this.props.t('screen.reports.'+this.props.screen+'.columns.'+t.title) : '',
                                        colSpan:t.col,
                                        style:'tableHeader',
                                        fillColor: "#2d4154"
                                    });

                                    for(var x = 0; x < t.col - 1; x++){
                                        title.push({});
                                    }
                                    return title;
                                });
                                
                                doc.content[1].table.body.unshift(title);

                                if(this.props.screen === 'check-in-face'){
                                    doc.content[1].table.widths = this.props.widths;
                                }

                                if(this.props.screen === 'entries'){
                                    doc.content[1].table.widths = this.props.widths;
                                }

                                if(this.props.screen === 'overtime'){
                                    doc.content[1].table.widths = this.props.widths;
                                }

                            }else{
                                doc.content[1].table.widths = this.props.widths;
                            }
                            
                            doc.styles.tableHeader.fontSize = 6.5;
                            doc.defaultStyle.fontSize = 6.5;
                        }
                    }
                ].filter(b => Object.keys(b).length > 0) // objEvidencesButton queda {} salvo en screen="visit" — no renderizar un botón vacío
            : (this.props.screen === 'employee')?
                [
                    {
                        extend:'excelHtml5',
                        className: "rs-btn excel-btn rs-btn-default "+(this.props.data.length > 0 ? "toolbar-btn-outline" : ""),
                        title: this.props.filename,
                        exportOptions:{
                            stripHtml: false,
                            format:{
                                header:(data, col, row)=>{
                                    return data;
                                },
                                body: (data, col, row)=>{
                                    return data;
                                }
                            }
                        },
                        action:function(e, dt, node, config){
                            /**/
                            config.exportOptions.columns = getIndex();
                            $.fn.dataTable.ext.buttons.excelHtml5.action.call(this, e, dt, node, config);                                
                        }
                    },
                    {
                        text:this.props.t('button.download_template'),//'Descargar plantilla',
                        className: "rs-btn rs-btn-default "+
                                    (this.props.data.length > 0 ?
                                        sessionStorage.getItem("suscription") !== "free" ?
                                            "toolbar-btn-outline"
                                        : "rs-btn-disabled"
                                    : ""),
                        action:( e, dt, node, config )=>{
                            if(sessionStorage.getItem("suscription") !== "free"){
                                $('.rs-btn-default').blur();
                                this.props.download();
                            }
                            
                        }
                    },
                    {
                        text:this.props.t('button.load_data'),//'Cargar datos',
                        className: "load-file rs-btn rs-btn-default "+
                                    (this.props.data.length > 0 ?
                                        sessionStorage.getItem("suscription") !== "free" ?
                                            "toolbar-btn-outline"
                                        : "rs-btn-disabled"
                                    : ""),
                    }
                ]
            : [],
            //columns: this.props.columns,
            oLanguage:{
                sProcessing: 'Procesando...',
                sZeroRecords: this.props.t('general.table.zero_records'),
                // sEmptyTable es HTML crudo (DataTables lo inyecta tal cual)
                // — mismo lenguaje visual que el estado vacío de las tarjetas
                // de Home (icono + título + texto), pero genérico porque este
                // componente es compartido por 11+ pantallas distintas.
                sEmptyTable: '<div class="table-empty-state">'+
                    '<i class="rs-icon rs-icon-inbox table-empty-icon"></i>'+
                    '<div class="table-empty-title">'+this.props.t('general.table.empty_title')+'</div>'+
                    '<div class="table-empty-text">'+this.props.t('general.table.empty_text')+'</div>'+
                    '</div>',
                sInfoFiltered: 'Filtrado de un total de _MAX_ registros',
                sSearch: this.props.t('general.table.search'),
                sLoadingRecords: 'Cargando...',
                oPaginate:{
                    sFirst: 'Primero',
                    sLast: 'Último',
                    sNext: 'Siguiente',
                    sPrevious: 'Anterior'
                },
                fnInfoCallback: null
            },
            paging: false,
            responsive: false,
            searching: this.props.searching,
            scrollY: this.props.scrollY ? this.props.scrollY : (this.props.scroll ? '32em' : false),
            scrollX: true,
            autoWidth: false,
            info: false,
            ordering: false,
            columnDefs: fixColumns,
            fixedColumns: true
        });

        this.dtInstance = table;

        // El buscador nativo de DataTables compara el término escrito tal
        // cual contra el dato ya normalizado arriba — hay que normalizar
        // también lo que el usuario escribe. Se reemplaza el binding propio
        // de DataTables (namespace .DT) por uno propio con el mismo set de
        // eventos, para que un solo keystroke dispare un solo draw.
        $('.dataTables_filter input', table.table().container())
            .off('keyup.DT search.DT input.DT paste.DT cut.DT')
            .on('keyup.accents search.accents input.accents paste.accents cut.accents', function(){
                table.search(stripAccents($(this).val())).draw();
            });

        const getIndex = ()=>{
            employeeColumns = [];

            this.props.columns.forEach((col, i)=>{
                if(i > 0 && col.title !== '' && col.visible){
                    employeeColumns.push(i);
                }
            });

            return employeeColumns;
        }

        if(this.props.btnNew){
            $('.dataTables_filter').append(
                '<button type="button" style="margin-left:10px;"'+
                    'class="new rs-btn rs-btn-default rs-btn-icon rs-btn-icon-placement-left rs-btn-icon-circle'+
                    (this.state.disabled_new ? '" ' : ' s-primary-btn"')+
                    'title="'+
                        (this.state.message === 'new' ?
                            this.props.t('button.new')
                        : this.props.t('error_alert.suscription_free')
                        )+
                    '"'+
                '>'+
                    '<i class="rs-icon rs-icon-plus"></i>'+
                    '<span class="rs-ripple-pond">'+
                        '<span class="rs-ripple" style="width: 56.304px; height: 56.304px; left: -11.9645px; top: -12.152px;">'+
                        '</span>'+
                    '</span>'+
                '</button>'
            )

            $('.new').click((e)=>{
                e.preventDefault();

                this.props.new();
            });
        
        }

        if(this.props.screen === 'employee'){
            $('.dt-buttons').append(
                '<input type="file" id="carga" class="file-template" style="display:none;" />'
            );

            $('.load-file').click((e)=>{
                e.preventDefault();

                if(sessionStorage.getItem("suscription") !== "free"){
                    $('.rs-btn-default').blur();
                    $('.file-template').val('');
                    $('.file-template').click();
                }
                
            });

            $('.file-template').change((e)=>{
                e.preventDefault();
                this.props.preview();
            });
          
        }

        this.props.columns.map((col, i)=>{
            var column = table.column(i);
            column.visible(col.visible);

            return col;
        })

        if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

        $('.dt-buttons').css('margin-right', this.props.updateColumns ? '150px' : '50px');

        this.setState({dtReady: true});
    }

    render(){
        return (
            <div className={"col-12 form-group tbl-data screen-"+this.props.screen} style={{fontSize: '12px'}}>
                <div className="column-visibility-toggle">
                    {this.props.updateColumns &&
                        <div className="columns">
                            <Dropdown
                                title={<><Icon icon="columns" /> {this.props.t('general.table.columns')}</>}
                                placement="bottomEnd"
                                className="columns-dropdown"
                            >
                                {this.props.columns.map((c, i)=>(
                                    this.props.report ?
                                        <Dropdown.Item key={i}>
                                            <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                                <input
                                                    type="checkbox"
                                                    className="col_show_hide"
                                                    data-column={i}
                                                    checked={c.visible}
                                                    onChange={(e)=>this.props.updateColumns(e, i)}
                                                /> {this.props.report ?
                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+c.name)
                                                : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+c.name)}
                                            </label>
                                        </Dropdown.Item>
                                    :
                                        i < this.props.columns.length - 1 &&
                                            <Dropdown.Item key={i}>
                                                <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                                    <input
                                                        type="checkbox"
                                                        className="col_show_hide"
                                                        data-column={i}
                                                        checked={c.visible}
                                                        onChange={(e)=>this.props.updateColumns(e, i)}
                                                    /> {c.special ? c.title :
                                                        this.props.report ?
                                                            this.props.t('screen.reports.'+this.props.screen+'.columns.'+c.name)
                                                        : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+c.name)
                                                    }
                                                </label>
                                            </Dropdown.Item>

                                ))}
                            </Dropdown>
                        </div>
                    }
                </div>
                
                <div className="table-responsive" style={{visibility: this.state.dtReady ? 'visible' : 'hidden'}}>
                    <table
                        key={this.state.tableKey}
                        className={
                            this.props.report ? "table table-auto" : "table table-fixed"
                        }
                        id="table"
                        ref={el => this.el = el}
                    >
                        <thead>
                            {this.props.report ?
                                <tr>
                                    {this.props.table_title.map((tbl, i)=>
                                        <th key={i} colSpan={tbl.col} style={{textAlign:'center'}} className={"s-table-titles"+(tbl.groupClass ? " "+tbl.groupClass : "")}>
                                            {tbl.title ? this.props.t('screen.reports.'+this.props.screen+'.columns.'+tbl.title) : ''}
                                        </th>
                                    )}
                                </tr>
                            :null}
                            <tr>
                                {this.props.columns.map((col, i)=>(
                                    <th key={i} style={{width:col.width}} className={"s-table-titles"+(col.groupClass ? " "+col.groupClass : "")}>{
                                        this.props.report ?
                                            col.name === 'face' ?
                                                this.props.screen === 'employees_activity' ?
                                                    this.props.t('screen.reports.employees_activity.columns.face')
                                                : <Icon icon="smile-o" size="2x" />
                                            : col.name === 'photo' ?
                                                <Icon icon="camera" size="lg" />
                                            :this.props.t('screen.reports.'+this.props.screen+'.columns.'+col.name)
                                        : col.special ? 
                                            col.title
                                        : col.title !== '' ?
                                            this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+col.name)
                                        : ''
                                    }</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.data.map((data, i)=>(
                                <tr key={i} className="s-table-content">
                                    {data.map((d, j)=>(
                                        data.length - 1 === j ?
                                            <td key={j}>
                                                {this.props.actions.length > 0 ?
                                                    this.props.actions.map((b, key)=>(
                                                        b.btn ?
                                                            b.icon !== null ?
                                                                <IconButton 
                                                                    icon={<Icon icon={b.icon} />} 
                                                                    key={key} 
                                                                    style={{marginLeft: 8}} 
                                                                    size="sm"
                                                                    title={b.title}
                                                                    onClick={(e)=>b.action(e, d)}
                                                                />
                                                            : <Button title={b.title} key={key} color="blue" style={{marginLeft: 8}} size="xs">
                                                                {b.name}
                                                            </Button>
                                                        : null
                                                    ))
                                                : (d.indexOf('data:image') !== -1 || d.indexOf('https') !== -1) ?
                                                    <img src={d} style={{width:'48px'}} alt="" />
                                                : d.toString().indexOf('icon') !== -1 ?
                                                    <div>
                                                        {this.props.screen === 'employees_activity' && d.split('/')[1] === 'MdManageSearch' ?
                                                        <Icon 
                                                            size="2x" 
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ? 
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        >
                                                            <MdManageSearch/>
                                                        </Icon>
                                                        :
                                                        this.props.screen === 'checks_map' /*||  this.props.screen === 'entries'*/ ?
                                                        <Icon 
                                                            size="2x" 
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ? 
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        >
                                                            {d.split('/')[1] === 'MdOutlineLocationOn'? <MdOutlineLocationOn/> : 
                                                                <span className='textLocationButton'>
                                                                    {d.split('/')[1]}
                                                                </span> 
                                                            }
                                                             
                                                        </Icon>
                                                        :
                                                        (this.props.screen === 'entries') && (d.split('/')[1] !== 'map-marker' && d.split('/')[1] !== 'check') ?
                                                        <Icon 
                                                            size="2x" 
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ? 
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        >
                                                        
                                                        <>
                                                            <span  className='labelLocationAsLink'>{d.split('/')[1]}</span> 
                                                        </>    
                                                    </Icon>
                                                        :
                                                        <Icon 
                                                            icon={d.split('/')[1]} 
                                                            size="2x" 
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ? 
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        />
                                                        }
                                                    </div>
                                                : d }

                                                {this.props.screen === 'employee' &&
                                                    data[0].toString().indexOf('icon') !== -1 &&
                                                        data[0].split('/')[4] === 'no_action' &&
                                                            <Icon
                                                                icon="toggle-off"
                                                                style={{marginLeft: 8}} 
                                                                size="lg"
                                                                title={this.props.t('screen.settings.employee.list.columns.active')}
                                                            />
                                                }
                                            </td>

                                        : <td key={j} style={
                                                this.props.screen === 'employees_activity' && d !== null && d.toString().indexOf('icon') !== -1 && d.split('/')[3] === 'entry' ?
                                                    {textAlign:'center'}
                                                : {}
                                            }>
                                            {d !== null ?
                                                this.props.screen === 'employees_activity' && d.toString().indexOf('type/') === 0 ?
                                                    <span className={"table-type-pill "+(d.split('/')[2] === 'in' ? 'is-in' : 'is-out')}>
                                                        {d.split('/')[1]}
                                                    </span>
                                                : d.toString().indexOf('icon') !== -1 ?
                                                    <div>
                                                    {this.props.screen === 'employees_activity' && d.split('/')[3] === 'entry' ?
                                                        <span
                                                            className={"table-face-badge "+(d.split('/')[1] === 'MdDone' ? 'is-valid' : 'is-invalid')}
                                                            title={this.props.t('screen.reports.employees_activity.columns.face')}
                                                        >
                                                            {d.split('/')[1] === 'MdDone' ? <MdDone/> : <MdClose/>}
                                                        </span>
                                                    : this.props.screen === 'employees_activity' && d.split('/')[3] === 'start_location' ?
                                                        <span
                                                            className="table-location-warning"
                                                            title={this.props.t('screen.reports.employees_activity.out_of_range')}
                                                            onClick={(e)=> this.props.actionIcon(e, i, d.split('/')[3])}
                                                        >
                                                            <MdOutlineLocationOn/> {this.props.t('screen.reports.employees_activity.out_of_range')}
                                                        </span>
                                                    :
                                                    ((this.props.screen === 'employees_activity' || this.props.screen === 'checks_map') || this.props.screen === 'entries' || this.props.screen === 'check-in-face' || this.props.screen === 'visit') && (d.split('/')[1] !== 'map-marker' && d.split('/')[1] !== 'check' && d.split('/')[1] !== 'close') ?
                                                        <Icon
                                                            size="2x"
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ?
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        >
                                                            {d.split('/')[1] === 'MdDone' ?
                                                                <MdDone/>
                                                            :
                                                            d.split('/')[1] === 'MdClose' ?
                                                                <MdClose/>
                                                            :
                                                            d.split('/')[1] === 'MdOutlineLocationOn' ?
                                                                <MdOutlineLocationOn/>
                                                            :
                                                            <>
                                                                <span className='labelLocationAsLink'>{d.split('/')[1]}</span>
                                                            </>
                                                            }

                                                        </Icon>
                                                        :
                                                        this.props.screen === 'employee' && ['face', 'location', 'email', 'phone'].indexOf(d.split('/')[3]) !== -1 ?
                                                        <span
                                                            className={"table-status-badge "+(d.split('/')[2] === '#2196F3' ? 'is-on' : 'is-off')}
                                                            style={{cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ?
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        >
                                                            <Icon icon={d.split('/')[1]} size="lg" />
                                                        </span>
                                                        :
                                                        <Icon
                                                            icon={d.split('/')[1]}
                                                            size="2x"
                                                            style={{color:d.split('/')[2], cursor: d.split('/')[4] === 'no_action' ? 'no-drop' : 'pointer'}}
                                                            onClick={(e)=>
                                                                d.split('/')[4] === 'no_action' ?
                                                                    e.preventDefault()
                                                                :d.split('/')[4] !== 'one' ?
                                                                    this.props.actionIcon(e, data[data.length-1], d.split('/')[3])
                                                                : this.props.actionIcon(e, i, d.split('/')[3])
                                                            }
                                                            title={this.props.report ?
                                                                d.split('/')[3] !== '' &&
                                                                    this.props.t('screen.reports.'+this.props.screen+'.columns.'+d.split('/')[3])
                                                            : this.props.t('screen.settings.'+this.props.screen+'.list.columns.'+d.split('/')[3])}
                                                        />
                                                    }
                                                    </div>
                                                : (d.indexOf('data:image') !== -1 ||  d.indexOf('https') !== -1)?
                                                    <img src={d} style={{width:'48px'}} alt="" />
                                                : d
                                            : ""}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    
}

export default TableList;